import React, { lazy, Suspense } from "react";
import { Navbar, Hero } from "../../components/landingHero";

const LandingBelowFold = lazy(() => import("../../components/landingSections"));
const PublicChatbot = lazy(() => import("../../components/chatbot/publicChatbot"));

const Landing: React.FC = () => {
    return (
        <div className="min-h-screen bg-white overflow-x-hidden">
            <Navbar />
            <main>
                <Hero />
                <Suspense fallback={null}>
                    <LandingBelowFold />
                </Suspense>
            </main>
            <Suspense fallback={null}>
                <PublicChatbot />
            </Suspense>
        </div>
    );
};

export default Landing;